import React from "react";
import { Layer, Stage } from "react-konva";
import Main from "../components/Layout";
import Sidebar from "../components/Sidebar";

import config from "../utils/config";
import TileShapeGroup from "../components/Builder/TileShapeGroup";
import SinkGroups from "../components/Builder/SinkGroup";
import GridStage from "../components/Builder/GridLine";
import StageWrapper from "../components/StageWrapper";

import { useGetBuilderDataQuery } from "../lib/redux/api/builder-api";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCanvasValues } from "../utils/canvas";
import { getDimensions, getLineAlignment, getSelectedVariation, getTileShape } from "../lib/redux/slices/dimensions-slice";
import { getSinks } from "../lib/redux/slices/sink-slice";
import { getHoles } from "../lib/redux/slices/holes-slice";
import { Spinner } from "../components/Spinner";
import AddToCart from "../components/Cart/AddToCart";
import styled, { css } from "styled-components";
import { rem, transparentize } from "polished";
import StepModal from "../components/StepModal";
import makePayload from "../components/Cart/AddToCart/make-payload";
import { addToCart } from "../lib/redux/slices/cart-slice";

const MainLayout = () => {
  const cartData = useSelector((s) => s.cart);
  const cartPayload = useSelector((s) => s);
  const dispatch = useDispatch();
  
  const { loading, data } = cartData;
  const currency = (data && data.currency) || "kr";

  //Canvas Default Scale
  const currentShape = useSelector(getTileShape);
  const { top, left, bottom, right } = useSelector(getDimensions);
  const lineAlignment = useSelector(getLineAlignment);
  const { canvasTop, canvasLeft, canvasBottom, canvasRight } = getCanvasValues(
    { top, left, bottom, right },
    currentShape,
    lineAlignment
  );
  const selectedVariation = useSelector(getSelectedVariation);

  const sinks = useSelector(getSinks);
  const holes = useSelector(getHoles);
  
  const maxHeightWidth = sinks.length + holes.length;
  const [canvasSize, setCanvasSize] = React.useState({
    width: canvasTop,
    height: currentShape === 'right' ? canvasRight : canvasLeft,
  });
  const [scale, setScale] = React.useState(1);
  

  const [canvasOffsetX, setCanvasOffsetX] = React.useState(50);
  const [canvasOffsetY, setCanvasOffsetY] = React.useState(50);
  const [canvasOffsetX1, setCanvasOffsetX1] = React.useState(0);
  const [canvasOffsetY1, setCanvasOffsetY1] = React.useState(0);

  const [openDrawer, onSetDrawer] = React.useState(false);

  const groupRef = React.useRef(null);
  const stageRef = React.useRef(null);
  const [params] = useSearchParams();

  const category = params.get("cat");
  const catId = params.get("id");

  const { isLoading, data: builderData = [] } = useGetBuilderDataQuery({
    category,
    catId,
  });

  const handleContinue = () => {
    onSetDrawer(!openDrawer);
    if (!openDrawer) {
      const payload = makePayload(cartPayload);
      dispatch(addToCart(payload));
    }
  };

  const handleResize = React.useCallback(() => {
    const ratio = window.innerWidth >= 768 ? 1.8: 2.8
    const scaleX = window.innerWidth / (canvasSize.width * config.defaultRatio / ratio + (canvasOffsetX ));
    const scaleY = window.innerHeight / (canvasSize.height * config.defaultRatio / ratio  + canvasOffsetY);
    let scale = scaleX < scaleY ? scaleX : scaleY;


    scale = scale > 1  ? 1 : scale ;
    setScale(scale);

    setCanvasSize({
      width: canvasTop,
      height: currentShape === 'right' ? canvasRight : canvasLeft ,
    });

  }, [canvasLeft, canvasOffsetX, canvasOffsetY, canvasRight, canvasSize.height, canvasSize.width, canvasTop, currentShape]);

  React.useEffect(() => {
    // Attach the resize event listener when the component mounts
    window.addEventListener("resize", handleResize);

    // Call handleResize initially to set the initial scale
    handleResize();

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  React.useEffect(() => {
    setCanvasSize({
      width: canvasTop,
      height: currentShape === 'right' ? canvasRight : canvasLeft ,
    });

    const ratio = window.innerWidth >= 768 ? 1.8 : 2.4

    const scaleX = window.innerWidth / (canvasTop * config.defaultRatio / ratio + (canvasOffsetX ));
    const scaleY = window.innerHeight / (canvasLeft * config.defaultRatio / ratio  + canvasOffsetY);
    let scale = scaleX < scaleY ? scaleX : scaleY;


    scale = scale > 1  ? 1 : scale ;
    setScale(scale);
    // handleResize()
    
  }, [canvasTop, canvasLeft, currentShape, canvasRight, selectedVariation, canvasOffsetX, canvasOffsetY,lineAlignment])


  const getContent = (title, data) => {
    return Object.entries(data).map((item) => {
              return item[1].length
                ? item[1].map((ite) => {
                    return (
                      <li>
                        <h6 dangerouslySetInnerHTML={{ __html: ite.title }} />
                        {/* <span>{ite.title}</span> */}
                        <span>{[ite.price, currency].join(" ")}</span>
                      </li>
                    );
                  })
                : null;
            })
  };

    const steps = builderData?.walkthrough || [];
    const isProductionUrl =
    process.env.NODE_ENV === "production" ? "/builderonly/" : "/";

  return (
    <>
      <Main handleContinue={handleContinue} openDrawer={openDrawer} onSetDrawer={onSetDrawer} stage={stageRef}>
        
          <StageWrapper
            // width={canvasSize.width  + canvasOffsetX}
            // height={canvasSize.height + canvasOffsetY}
            className='stageWrapper'
          >
            {steps && steps.length ? <StepModal data={steps} /> : null}
            {/* <GridStage size={16} /> */}
            {!isLoading && (
            <div
              className="konva-stage"
              style={{
                transform: `scale(${scale})`,
                // transformOrigin: '10% 20%',
                transformOrigin: `0 50%`,
                margin: 'auto',
                padding: `${config.canvasSpace * scale}px`,
                width: '100'
              }}
            >
              <Stage
                width={canvasSize.width  + 60  + (canvasOffsetX * ((maxHeightWidth + 1)))}
                height={canvasSize.height + 60  + (canvasOffsetY  * ((maxHeightWidth + 1)))}
                x={canvasOffsetX}
                y={canvasOffsetY}
                ref={stageRef}
              >

                <Layer>
                  {/* L-shape Group */}
                  <TileShapeGroup
                    {...{
                      groupRef,
                      canvasOffsetX,
                      canvasOffsetY,
                      canvasOffsetX1,
                      canvasOffsetY1,
                      scale,
                    }}
                  />
                  <SinkGroups
                    {...{
                      canvasOffsetX,
                      canvasOffsetY,
                      setCanvasOffsetX,
                      setCanvasOffsetY,
                      setCanvasOffsetX1,
                      setCanvasOffsetY1,
                      stageRef,
                    }}
                  />
                </Layer>
              </Stage>
            </div>
            )}
            {data ? (
           <CartDetails className="content">
            <div className="content-wrapper">
              <div className="cart-content">
                 <div className="cart-details-list">
                  <ul>
                    {getContent("ARTIKLAR", data.artiklar)}
                    {data?.kantprofiler?.length
                      ? getContent("KANTPROFILER", {
                          data: data.kantprofiler,
                        })
                      : null}
                  </ul>
                   <div className="scroll-placeholder" >
                     <img src={`${isProductionUrl}arrow.svg`} alt={''} width={60} />
                     </div>
                </div>
               
            </div> 

            <div className="add-to-cart">
              <div className="item-body">
                  <ul>
                    {/* <li>
                      <span>{data.vat.title}</span>
                      <span>{data.vat.formatted_price}</span>
                    </li> */}
                    <li>
                      <h3>{data.totalAmount.title} :  {data.totalAmount.formatted_price}</h3>
                    
                    </li>
                  </ul>
                </div>
              <AddToCart stage={stageRef} />
            </div>
             
            </div>
            </CartDetails>
          ) :null}
           {loading !== "resolved" &&<Spinner strokeWidth={10} width={50} className="centerAlign" fixed  hasContainerOpacity={0.8} fullWidth/> }
          </StageWrapper>
        
        <Sidebar stage={stageRef} canvasOffsetX={canvasOffsetX} isLoading={isLoading} handleContinue={handleContinue}/>
      </Main>
    </>
  );
};

export default MainLayout;


const CartDetails = styled.div`
  ${({ theme }) => css`
  padding: 0 30px;

  .content-wrapper{
    display: grid;
    grid-template-columns: 65% calc(35% - 15px);
    gap: 15px;
    position: relative;
    border-top: 1px solid #000;
    padding-top: ${rem(30)};
    margin-top: ${rem(30)};

    @media (max-width: 991px) {
      display: block;
    }

    .add-to-cart {
      @media (max-width: 991px) {
      margin-top: 30px;;
      }
      ul {
        list-style: none;
        margin:0;
        padding: 0;

        li {
          h3 {
            font-size: ${rem(18)};
            font-weight: bold;
          }
        }
      }
    }

    .cart-details-list {
      position: relative;
      .scroll-placeholder {
         background: linear-gradient(90deg, rgb(255 255 255 / 0%) 0%, #f8f8f8 80%);
        width: 50px;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        pointer-events: none;
        user-select: none;

        img {
          width: 15px;
          margin-left: auto;
          opacity: 0.5;
        }

      }

      
      ul {
        list-style: none;
        margin:0 30px 0 0;
        padding: 0;
        display: flex;
        flex-wrap: nowrap;
        gap: 30px;
        overflow: auto hidden;
        padding: 0 0 20px 0;

       &::-webkit-scrollbar {
          height: 3px;

          /* Track */
          &-track {
            box-shadow: inset 0 0 3px ${theme.colors.gray["500"]};
            border-radius: 10px;
          }

          /* Handle */
          &-thumb {
            background: ${theme.colors.primary};
            border-radius: 10px;
            height: 3px;

            &:hover {
              background: ${transparentize(0.2, theme.colors.primary)};
            }
          }
        }

        li {
          flex: auto;
          min-width: 200px;
          border-right: 1px solid #ddd;
          padding-right: 20px;

          h6 {
            font-size: ${rem(18)};
            font-weight: normal;
            margin-bottom: 10px; 
          }

          span {
             font-size: ${rem(18)};
              color:${theme.colors.primary};
              font-weight: 600;
          }
        }
      }
    }
  }
    
  `}
`;